import React from "react"
import { NavLink } from "react-router-dom"

const SubmenuArrowIcon = (props) => {
  return (
    <span
      className={`right-icon glyphicon glyphicon-menu-${
        props.isSubmenuOpen ? "up" : "down"
      }`}
    />
  )
}

const SideBarNavLink = (props) => {
  const { linkClass, children, ...navLinkProps } = props

  const classes = `sidebar-link ${linkClass || ""}`
  return (
    <NavLink activeClassName="active" className={classes} {...navLinkProps}>
      {children}
    </NavLink>
  )
}

export { SideBarNavLink, SubmenuArrowIcon }
